import { LiveClient, type LiveClientOptions } from './client.ts';

// The page's one live client. The shell starts it after login and stops it on logout.

let client: LiveClient | undefined;

/** The page's live client, made on first use. */
export function liveClient(): LiveClient {
  client ??= new LiveClient();
  return client;
}

/** Replaces the page's live client, for tests (a fake EventSource). */
export function setLiveClient(next: LiveClient | LiveClientOptions): LiveClient {
  client?.stop();
  client = next instanceof LiveClient ? next : new LiveClient(next);
  return client;
}
